import { type RedeemOption } from "@/hooks/useRewards";

interface Props {
  option: RedeemOption;
  currentPoints: number;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

export default function RedeemConfirmModal({ option, currentPoints, onConfirm, onCancel, loading }: Props) {
  const remaining = currentPoints - option.points;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" dir="rtl">
      <div className="bg-[#111] border border-white/10 rounded-3xl p-6 w-full max-w-sm relative overflow-hidden">
        {/* Top glow */}
        <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-amber-400/0 via-amber-400/60 to-amber-400/0"></div>

        {/* Icon */}
        <div className="w-14 h-14 flex items-center justify-center bg-amber-400/15 border border-amber-400/25 rounded-2xl mx-auto mb-5">
          <i className="ri-exchange-dollar-line text-amber-400 text-2xl"></i>
        </div>

        <h3 className="text-white text-lg font-black text-center mb-1" style={{ fontFamily: "'Cairo', sans-serif" }}>
          تأكيد الاستبدال
        </h3>
        <p className="text-gray-500 text-xs text-center mb-6" style={{ fontFamily: "'Cairo', sans-serif" }}>
          هل أنت متأكد من استبدال نقاطك؟
        </p>

        {/* Summary */}
        <div className="bg-[#1a1a1a] border border-white/8 rounded-2xl p-4 mb-5 flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <span className="text-gray-500 text-xs" style={{ fontFamily: "'Cairo', sans-serif" }}>الخصم المكتسب</span>
            <span className="text-amber-400 text-base font-black" style={{ fontFamily: "'Cairo', sans-serif" }}>{option.label}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-gray-500 text-xs" style={{ fontFamily: "'Cairo', sans-serif" }}>النقاط المستخدمة</span>
            <span className="text-red-400 text-sm font-black" style={{ fontFamily: "'Cairo', sans-serif" }}>- {option.points} نقطة</span>
          </div>
          <div className="border-t border-white/8 pt-3 flex items-center justify-between">
            <span className="text-gray-400 text-xs font-bold" style={{ fontFamily: "'Cairo', sans-serif" }}>رصيدك بعد الاستبدال</span>
            <span className="text-white text-sm font-black" style={{ fontFamily: "'Cairo', sans-serif" }}>{remaining} نقطة</span>
          </div>
        </div>

        <p className="text-gray-600 text-[11px] text-center mb-5" style={{ fontFamily: "'Cairo', sans-serif" }}>
          سيُنشأ كوبون خصم فوري صالح لمدة 30 يوماً
        </p>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            disabled={loading}
            className="flex-1 border border-white/10 rounded-xl py-3 text-sm font-bold text-gray-400 hover:text-white hover:border-white/20 transition-all cursor-pointer whitespace-nowrap disabled:opacity-50"
            style={{ fontFamily: "'Cairo', sans-serif" }}
          >
            إلغاء
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 bg-amber-400 hover:bg-amber-300 text-black rounded-xl py-3 text-sm font-black transition-all cursor-pointer whitespace-nowrap disabled:opacity-50 flex items-center justify-center gap-2"
            style={{ fontFamily: "'Cairo', sans-serif" }}
          >
            {loading ? (
              <><i className="ri-loader-4-line animate-spin"></i> جاري الإنشاء...</>
            ) : (
              <><i className="ri-check-line"></i> تأكيد الاستبدال</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
